import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const author: AdminBlockTypeAttribute = {
  label: 'Show author',
  key: 'author',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default author;
